import { differenceInDays, isSameDay } from "date-fns";

export function formatDateWithTime(date) {
    return new Date(date * 1000).toLocaleDateString('en-US', {
        month: "short",
        day: "2-digit",
        // year: "numeric",
        hour: '2-digit',
        minute: '2-digit',
        hour12:true,
    })
}

export function formatDateWithTimeYear(date) {
    return new Date(date * 1000).toLocaleDateString('en-US', {
        month: "short",
        day: "2-digit",
        year: "numeric",
        hour: '2-digit',
        minute: '2-digit',
        hour12:true,
    })
}

export function formatDate(date) {
    return new Date(date * 1000).toLocaleDateString('en-US', {
        month: "short",
        day: "2-digit",
        year: "numeric"
    })
}

export const alphaformatDateTime = (timestamp) => {
    if (!timestamp || timestamp === -1) {
      return { dateStr: '-', timeStr: '-' };
    }
    
    const dateObj = new Date(parseInt(timestamp) * 1000);
    
    const dateStr = dateObj.toLocaleDateString('en-IN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
      
      const timeStr = dateObj.toLocaleTimeString('en-IN', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true, 
      });
      
      
    
    return { dateStr, timeStr:timeStr.toUpperCase() };
  };

export function formatDateYYYYMMDD(date) {
    let dat = new Date(date * 1000);
    return [dat.getFullYear(), ('0' + (dat.getMonth() + 1)).slice(-2), ('0' + dat.getDate()).slice(-2)].join('-');
}

export function ISODateString(d) {

    let d1 = new Date(d * 1000);
    d1.setHours(d1.getHours() + 5);
    d1.setMinutes(d1.getMinutes() + 30);
    d1 = d1.toISOString().slice(0, 16)
    return d1
}

export function NEWISODateString() {

    const d = Math.floor(new Date().getTime() / 1000);
    let d1 = new Date(d * 1000);
    d1.setHours(d1.getHours() + 5);
    d1.setMinutes(d1.getMinutes() + 30);
    d1 = d1.toISOString().slice(0, 16)
    return d1
}

export function UpdatedDate(date) {
    let d = new Date(date * 1000);
    let utc = d.getTime() + (d.getTimezoneOffset() * 60000);
    let nd = new Date(utc + (3600000 * +5.5));
    var ist = nd.toUTCString();
    return ist.slice(0, 26)
}

export function daysBetween(startDateString, endDateString, dateList) {
    // const startDate = new Date(startDateString.slice(0, 10));
    // const endDate = new Date(endDateString.slice(0, 10));
    // const millisecondsPerDay = 86400000; // 24 * 60 * 60 * 1000
    // return Math.round((endDate - startDate) / millisecondsPerDay);

    let daysCount = 0;
    if(dateList.length){
        dateList.map((range) => {
          let start_date = new Date(range.sdate),
            end_date = new Date(range.edate);
          daysCount += differenceInDays(end_date, start_date) + 1;
        });
    }
    else{
        let start_date = new Date(startDateString),
            end_date = new Date(endDateString);
          daysCount += differenceInDays(end_date, start_date) + 1;
    }
  return daysCount;
}

export const isExpired = (start_date, end_date) => {
    const time = Math.round(new Date().setHours(5, 30, 0, 0) / 1000);
    if (start_date > end_date || start_date > time || time > end_date) {
        return true;
    }

    return false;
}

export const SameDay = (dateString1, dateString2) => {
    const date1 = new Date(dateString1);
    const date2 = new Date(dateString2);
    const isSameDay = date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate();
    return isSameDay;
}

export const DatetoTimestamp = (date) => {
    const timestamp = new Date(date) / 1000
    return formatDateWithTime(timestamp)
}

export const End_date_cpd = (date) => {
    const timestamp = Math.round(new Date(date).setHours(23, 59, 59, 59) / 1000)
    return formatDateWithTime(timestamp)

}
export function formatDateDDMMYYY(date) {
    var dat = new Date(date * 1000);
    var day = dat.getDate();
    var month = dat.getMonth() + 1;
    var year = dat.getFullYear();
    var formattedDay = day < 10 ? '0' + day : day;
    var formattedMonth = month < 10 ? '0' + month : month;
    var formattedDate = formattedDay + '/' + formattedMonth + '/' + year;

    return formattedDate;

}
export function formatDateToReadable(date) {
    let given_date = new Date(date * 1000);
    let current_date =
        given_date.getDate() > 9
            ? given_date.getDate()
            : JSON.stringify(given_date.getDate()).padStart(2, "0");
    return `${given_date.getFullYear()}-${given_date.getMonth() + 1
        }-${current_date}`;
}

export function getEnd_date_limit_for_CPD(date) {
    const newTimeStr = "23:50";

    const inputDate = new Date(date);
    const [hours, minutes] = newTimeStr.split(':');
    
    inputDate.setHours(hours);
    inputDate.setMinutes(minutes);
    const formattedDate = `${inputDate.getFullYear()}-${(inputDate.getMonth() + 1).toString().padStart(2, '0')}-${inputDate.getDate().toString().padStart(2, '0')}T${inputDate.getHours().toString().padStart(2, '0')}:${inputDate.getMinutes().toString().padStart(2, '0')}`;
    return formattedDate

}
export const formatFullDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};
export const  formatDatewithMonthReadable=(date)=> {
    return new Date(date * 1000).toLocaleDateString('en-GB', {
        day: "2-digit",     
        month: "short",       
        year: "numeric"       
    }).replace(',', '');   
}